<template lang="pug">
.resend-history-table-component
  //- テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :current-page="currentPage"
    :per-page="perPage"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    //- ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    //- レコード無し
    template(#empty)
      .empty-message
        span 情報がありません
    //- フィルター後レコード無し
    template(#emptyfiltered)
      .empty-message
        span 情報がありません

    //- セル：再送日時
    template(#cell(sendDatetime)="row")
      span {{ convertSendDatetimeLabel(row.item.sendDatetime) }}
    //- セル：宛先
    template(#cell(targets)="row")
      .d-flex
        span.target-name.flex-fill.align-self-center {{ row.item.targetNames.join('、') }}
        button.btn.target-list-btn(@click="onShowTarget(row.item)") 宛先一覧
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { QuestionnaireHistory, TargetType } from "@/commons/services/Questionnaires";

/**
 * ### 再送履歴テーブルコンポーネント
 */
@Component({})
export default class ResendHistoryTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<ResendHistoryTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<ResendHistoryTableField>;
  /** 全体行数 */
  @Prop({ required: true })
  totalRows!: number;
  /** 現在のページ */
  @Prop({ required: true })
  currentPage!: number;
  /** 1ページあたりの表示行数 */
  @Prop({ required: true })
  perPage!: number;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<ResendHistoryTableItem> {
    return this.value;
  }

  public onShowTarget(item: ResendHistoryTableItem): void {
    this.$emit("onShowTarget", item);
    return;
  }

  public convertSendDatetimeLabel(sendDatetime: number | null): string {
    if (sendDatetime == null) {
      return "";
    }
    const datetime: string = this.$dateUtil.convertNumberToString(sendDatetime, "mm月dd日 hh:MM");
    return datetime;
  }
}

/** テーブルの列名の情報 */
export interface ResendHistoryTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface ResendHistoryTableItem extends QuestionnaireHistory {
  /** 宛先種別 */
  targetType: TargetType;
  /** 宛先(名前) */
  targetNames: string[];
}
</script>

<style lang="scss" scoped>
.resend-history-table-component {
  width: 100%;
}
</style>
